export default __webpack_public_path__ + "static/media/offer8.6fd4c84a.jpg";